module.exports = __webpack_public_path__ + "media/images/header-logo-85014751fab22a93733dcd3ddaf1b405.png";